var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 4.6665V11.6665C12.833 12.9557 10.4822 13.9998 7.58301 13.9998C4.68384 13.9998 2.33301 12.9557 2.33301 11.6665V4.6665",
    stroke: "#80c5d6 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 8.16659C12.833 9.45575 10.4822 10.4999 7.58301 10.4999C4.68384 10.4999 2.33301 9.45575 2.33301 8.16659M18.6663 3.49992H22.1663C22.7852 3.49992 23.3787 3.74575 23.8163 4.18334C24.2538 4.62092 24.4997 5.21441 24.4997 5.83325V9.33325M9.33301 24.4999H5.83301C5.21417 24.4999 4.62068 24.2541 4.18309 23.8165C3.74551 23.3789 3.49967 22.7854 3.49967 22.1666V18.6666M20.4163 22.1666V25.6666M23.9163 25.6666H16.9163M12.833 4.66659C12.833 5.95575 10.4822 6.99992 7.58301 6.99992C4.68384 6.99992 2.33301 5.95575 2.33301 4.66659C2.33301 3.37742 4.68384 2.33325 7.58301 2.33325C10.4822 2.33325 12.833 3.37742 12.833 4.66659ZM25.6663 22.1666V15.1666H15.1663V22.1666H25.6663Z",
    stroke: "#80c5d6 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.bbb24089c0995d9d949a55a782c83c86.svg";
export { ForwardRef as ReactComponent };